module.exports = require('./dist/chains.js').Chains;



//////////////////
// WEBPACK FOOTER
// ./node_modules/c4s/index.js
// module id = 2hc4
// module chunks = 0